import React from 'react';
import { Search, RefreshCw } from 'lucide-react';

const CustomerSearch = ({ searchTerm, onSearchChange, totalCustomers, totalStamps, onRefresh, refreshing }) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="text-2xl font-bold text-gray-900">고객 관리</h2>
        <div className="flex items-center gap-2 w-full sm:w-auto">
          <div className="relative flex-1 sm:w-80 lg:w-96">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
              type="text"
              placeholder="전화번호 검색 (끝자리 4자리)"
              value={searchTerm}
              onChange={onSearchChange}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full"
            />
          </div>
          {/* 목록은 화면 진입 시 한 번만 불러오고 실시간으로 갱신되지 않는다.
              방금 다른 곳(태블릿 등)에서 막 등록/적립된 고객은 이 버튼을
              눌러 새로고침해야 검색에 잡힌다. */}
          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            title="목록 새로고침"
            className="shrink-0 p-2 border border-gray-300 rounded-lg text-gray-500 hover:bg-gray-50 disabled:opacity-50"
          >
            <RefreshCw className={`w-4 h-4 ${refreshing ? 'animate-spin' : ''}`} />
          </button>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="p-6 border-b">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-semibold">등록된 고객 ({totalCustomers}명)</h3>
            {/* <div className="text-sm text-gray-500">
              총 {totalStamps}개 스탬프 적립
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerSearch;